import { render, staticRenderFns } from "./folderModal.vue?vue&type=template&id=56d4cff2&lang=html&"
import script from "./folderModal.vue?vue&type=script&lang=js&"
export * from "./folderModal.vue?vue&type=script&lang=js&"
import style0 from "./folderModal.vue?vue&type=style&index=0&id=56d4cff2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports